import { ListSubheader, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { Country, State } from "models/Geography";
import { groupBy } from "lodash";
import { useAuthContext } from "AuthContextWrapper";
import { useEffect, useState } from "react";

export interface IProps {
  disabled?: boolean,
  stateId?: string,
  label?: string,
  allowedCountryIds?: number[],
  showCountrySubheader?: boolean,
  renderParams?: any,
  readOnly?: boolean,
  overrideOptions?: JSX.Element[],
  onStateIdChange: (id:string) => void,
  size?: "small"|"medium",
}

export function SelectState(props:IProps):JSX.Element {
  const { countries, states } = useAuthContext()
  const [ myOptions, setMyOptions ] = useState<JSX.Element[]>(props.overrideOptions as JSX.Element[])

  useEffect(() => {
    if(!countries || !states) {
      return
    }

    setMyOptions(getEstateLocationOptions(countries, states, props.allowedCountryIds, props.showCountrySubheader))
  }, [props.allowedCountryIds, countries, states])


  return <Select
    fullWidth
    readOnly={props.readOnly}
    size={props.size || "medium"}
    name="state"
    disabled={props.disabled}
    value={props.stateId?.toString()}
    label={props.label || ""}
    onChange={(e:SelectChangeEvent) => {
      e.stopPropagation()
      e.preventDefault()
      if(e.target.value) {
        props.onStateIdChange(e.target.value)
      }
    }}
    {...props.renderParams}
  >
    {myOptions}
  </Select>
}


function getEstateLocationOptions(countries: Country[], states: State[], allowedCountryIds?:number[], showCountrySubheader?:boolean):JSX.Element[] {
  const items = [];
  if(allowedCountryIds && allowedCountryIds.length > 0) {
    countries = countries.filter(c => !!allowedCountryIds.find(acId => c.id === acId))
  }

  // Sort by Country
  const groupByCountry = groupBy(states, (state) => {
    return state.countryId;
  });

  for (const [key, states] of Object.entries(groupByCountry)) {
    const country = countries.find((c) => c.id == parseInt(key));
    if (country) {
      if(showCountrySubheader) {
        items.push(
          <ListSubheader
            key={country.code}
            sx={{
              borderTop: "1px solid #e3e3e3",
              borderBottom: "1px solid #e3e3e3",
              backgroundColor: "#F2F2FF",
              fontWeight: "bold",
            }}
          >
            {country.name}
          </ListSubheader>
        );
      }

      for (const state of states) {
        items.push(
          <MenuItem key={state.id} value={state.id}>
            {state.fullName}
          </MenuItem>
        );
      }
    }
  }
  return items;
}